import type { TFunction } from "i18next";
import type { Schema } from "@/shared/components/Form/types";
import { countryOptions } from "@/shared/utils/countries";

type CountryAccessTypeValue = "ALL" | "INCLUDE" | "EXCLUDE";

const TYPE_LABEL_KEYS: Record<CountryAccessTypeValue, string> = {
  ALL: "countryAccesses.type.ALL",
  INCLUDE: "countryAccesses.type.INCLUDE",
  EXCLUDE: "countryAccesses.type.EXCLUDE",
};

export const getCountryAccessFormSchema = (t: TFunction): Schema => ({
  _main: {
    type: "block",
    hideHeader: true,
    xs: 12,
    md: 8,
    subschema: {
      title: {
        type: "text",
        label: t("countryAccesses.form.titleLabel"),
        required: true,
        xs: 12,
        fullWidth: true,
      },
      type: {
        type: "select",
        label: t("countryAccesses.form.typeLabel"),
        required: true,
        xs: 12,
        fullWidth: true,
        options: (Object.keys(TYPE_LABEL_KEYS) as CountryAccessTypeValue[]).map(
          (value) => ({ value, label: t(TYPE_LABEL_KEYS[value]) })
        ),
      },
      countries: {
        type: "select",
        label: t("countryAccesses.form.countriesLabel"),
        multiple: true,
        xs: 12,
        fullWidth: true,
        // Названия стран из shared-справочника пока не переводятся (deferred,
        // как в platformPages).
        options: countryOptions,
        visibleCheck: ({ allValues }) => allValues?.type !== "ALL",
      },
    },
  },
});
